import React, { useState, useEffect } from 'react';

import { IoMdArrowRoundDown } from 'react-icons/io';
import { MdContentCopy } from 'react-icons/md';

import '../../styles/pages/ContactPage.scss';

import Drone from '../animations/Drone.tsx';
import ContactForm from '../UI/ContactForm.tsx';

import setPageTitle from '../../utils/setPageTitle.ts';

function ContactPage(): React.ReactElement {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [emailCopied, setEmailCopied] = useState(false);

  const laptopWidth = 1366;

  setPageTitle('Contact Arthur! 📲');

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [windowWidth]);

  return (
    <div className="contact-page-bg--container">
      <div className="blend-in-out">
        {windowWidth >= laptopWidth ? <Drone /> : null}
        <main className="contact-page container">
          <ContactForm />

          <div className="contact-page__details text-hue-rotate">
            <IoMdArrowRoundDown className="details-icon" />
            <span>
              arthuriturres.co@gmail.com &nbsp;
              <MdContentCopy
                title="Copy email to clipboard"
                className="copy-icon"
                onClick={() => {
                  navigator.clipboard.writeText('arthuriturres.co@gmail.com');

                  setEmailCopied(true);

                  setTimeout(() => {
                    setEmailCopied(false);
                  }, 2000);
                }}
              />
            </span>

            {emailCopied && (
              <span className="email-copied">Email copied to clipboard!</span>
            )}
          </div>
        </main>
      </div>
    </div>
  );
}

export default ContactPage;
